// Run Manager is using our Forio Account
const runManagerAccount = {
  run: {
    account: 'steer-group',
    project: 'mcsim',
    model: 'Midlands - Scenarios.vmfx',
    server: {
      host: 'api.forio.com',
    },
    files: {
      ctx2: 'Midlands - Scenarios.ctx2',
      DefineScenarios: 'Define scenarios_clean_v3.xlsx',
      Export: 'export1.xlsx',
      InitialValues: 'initial_values.xlsx',
      parameters: 'parameters.xlsx',
      Reallocate: 'Reallocate HH to houses.tab',
      transport: 'transport.xlsx',
    },
  },
  strategy: 'always-new',
}

const scenarios = [
  {
    name: 'Baseline',
    title: 'Baseline',
    description: 'XXXXXXXXXX',
    baselineId: 'scenario1',
  },
]

const zones = [
  { name: 'ZUrban', label: 'Urban' },
  { name: 'ZRural', label: 'Non-urban' },
  { name: 'ZCore', label: 'Total' },
]

const skills = [
  { name: 'Manual', label: 'Manual' },
  { name: 'Skilled', label: 'Skilled' },
  { name: 'Expert', label: 'Expert' },
]

const businessTypes = [
  { name: 'Primary', label: 'Primary' },
  { name: 'Finance and business', label: 'Finance & Business' },
  { name: 'Retail and Catering', label: 'Retail & Catering' },
  { name: 'Industry and Manufacturing', label: 'Industry & Manufacturing' },
  { name: 'Education and Other services', label: 'Education & Other' },
]

const subscriptOptions = {
  zones,
  skills,
  businessTypes,
}

const outputCategories = [
  { label: 'Economic Recovery & Growth', reference: 'ER' },
  { label: 'Levelling-up', reference: 'LU' },
  { label: 'Climate Change and Carbon', reference: 'CC' },
]

// The output variables we are after
// Format options: http://numeraljs.com/#format
const outputs = [
  {
    name: 'Jobs by zone category',
    label: 'Jobs by zone category',
    format: '0.00A',
    display_in_results: true,
    subscripts: ['zones'],
    higher_than_base_is_better: true,
    category: 'ER',
  },
  {
    name: 'Jobs filled by type and zone category',
    label: 'Employment (by job skill type)*',
    format: '0.0A',
    display_in_results: true,
    subscripts: ['skills', 'zones'],
    higher_than_base_is_better: true,
    category: 'ER',
  },
  {
    name: 'Jobs filled by business type and zone category',
    label: 'Employment (by business type)*',
    format: '0.0A',
    display_in_results: true,
    subscripts: ['businessTypes', 'zones'],
    higher_than_base_is_better: true,
    category: 'ER',
  },
  {
    name: 'Population by zone category',
    label: 'Population',
    format: '0.0A',
    display_in_results: true,
    subscripts: ['zones'],
    higher_than_base_is_better: true,
    category: 'ER',
  },
  {
    name: 'Commercial property price index by zone category',
    label: 'Commercial property price index',
    format: '0.0',
    display_in_results: true,
    subscripts: ['zones'],
    higher_than_base_is_better: true,
    category: 'ER',
  },
  {
    name: 'House price index by zone category',
    label: 'Housing price index',
    format: '0.0',
    display_in_results: true,
    subscripts: ['zones'],
    higher_than_base_is_better: true,
    category: 'ER',
  },
  {
    name: 'GVA by zone categories',
    label: 'Gross Value Added',
    format: '$0,0.00a',
    display_in_results: true,
    subscripts: ['zones'],
    higher_than_base_is_better: true,
    category: 'LU',
    no_change_limit: 1000000,
  },
  {
    name: 'WF unemployment rate by zone category',
    label: 'Workforce Unemployment rate',
    format: '0.0%',
    display_in_results: true,
    subscripts: ['zones'],
    higher_than_base_is_better: false,
    category: 'LU',
    no_change_limit: 0.1,
  },
  {
    name: 'CO2 emissons by destination zone category',
    label: 'CO2 Emissions (KTonnes pa) from transport',
    format: '0.0',
    display_in_results: true,
    subscripts: ['zones'],
    higher_than_base_is_better: false,
    category: 'CC',
  },
  {
    name: 'Public transport TTW trips by destination category',
    label: 'Public transport commute trips per day',
    format: '0.0A',
    display_in_results: true,
    subscripts: ['zones'],
    higher_than_base_is_better: true,
    category: 'CC',
    no_change_limit: 100,
  },
  {
    name: 'Car ttw mode share by destination category',
    label: 'Car mode share',
    format: '0.0%',
    display_in_results: true,
    subscripts: ['zones'],
    higher_than_base_is_better: true,
    category: 'CC',
    no_change_limit: 100,
  },
  {
    name: 'Walk ttw mode share by destination category',
    label: 'Walking / cycling mode share',
    format: '0.0%',
    display_in_results: true,
    subscripts: ['zones'],
    higher_than_base_is_better: true,
    category: 'CC',
    no_change_limit: 100,
  },
]

const inputCategories = [
  { name: 'Private car', reference: 'PC' },
  { name: 'Road Pricing', reference: 'RP' },
  { name: 'Rail', reference: 'RL' },
  { name: 'Bus & Coach', reference: 'BC' },
  { name: 'Walk & cycle', reference: 'WC' },
  { name: 'New mobility', reference: 'NM' },
  { name: 'Freight', reference: 'FR' },
  { name: 'Behaviour change', reference: 'BE' },
]

// All the input variables and their initial value
const inputs = [
  {
    label: 'Increase Road capacity (within urban areas)',
    description:
      'Do you want to make it easier to drive your car in towns and cities? This option increases road capaicty for private car travel within urban areas by {{PARAMETERS_SCHEMES_B12}}%.',
    reference: 'PC1',
    oneoff: false,
    credit: 20,
    modelVariable: 'Increase Highway Capacity Urban',
    category: 'PC',
    switches: [
      {
        if: true,
        otherVariable: 'Reduce Highway Capacity Urban',
        action: 'DISABLE',
      },
      {
        if: false,
        otherVariable: 'Reduce Highway Capacity Urban',
        action: 'ENABLE',
      },
    ],
  },
  {
    label: 'Reduce Road capacity (within urban areas)',
    description:
      'Do you want to make it harder to drive your car in towns and cities? This option reduces road capaicty for private car travel within urban areas by {{PARAMETERS_SCHEMES_B13}}%.',
    reference: 'PC2',
    oneoff: false,
    credit: 5,
    modelVariable: 'Reduce Highway Capacity Urban',
    category: 'PC',
    switches: [
      {
        if: true,
        otherVariable: 'Increase Highway Capacity Urban',
        action: 'DISABLE',
      },
      {
        if: false,
        otherVariable: 'Increase Highway Capacity Urban',
        action: 'ENABLE',
      },
    ],
  },
  {
    label: 'Increase Road capacity (between urban areas)',
    description:
      'Do you want to make it easier to drive your car from one town/city to another? This option increases road capaicty for private car travel between urban areas by {{PARAMETERS_SCHEMES_B24}}%.',
    reference: 'PC3',
    oneoff: false,
    credit: 25,
    modelVariable: 'Increase Highway Capacity Inter Urban',
    category: 'PC',
    switches: [
      {
        if: true,
        otherVariable: 'Reduce Highway Capacity Inter Urban',
        action: 'DISABLE',
      },
      {
        if: false,
        otherVariable: 'Reduce Highway Capacity Inter Urban',
        action: 'ENABLE',
      },
    ],
  },
  {
    label: 'Reduce Road capacity (between urban areas)',
    description:
      'Do you want to make it harder to drive your car from one town/city to another? This option reduces road capaicty for private car travel between urban areas by {{PARAMETERS_SCHEMES_B25}}%.',
    reference: 'PC4',
    oneoff: false,
    credit: 10,
    modelVariable: 'Reduce Highway Capacity Inter Urban',
    category: 'PC',
    switches: [
      {
        if: true,
        otherVariable: 'Increase Highway Capacity Inter Urban',
        action: 'DISABLE',
      },
      {
        if: false,
        otherVariable: 'Increase Highway Capacity Inter Urban',
        action: 'ENABLE',
      },
    ],
  },
  {
    label: 'Road pricing (urban)',
    description:
      'Do you want to make it more expensive to drive your car into town/city centers? This intervention introduces a {{PARAMETERS_SCHEMES_B35}} pence congestion charge for car journeys traveling into an urban area.',
    reference: 'RP1',
    oneoff: false,
    credit: -5,
    modelVariable: 'Increase Road Pricing Urban',
    category: 'RP',
  },
  {
    label: 'Road pricing (between urban areas)',
    description:
      'Do you want to make it more expensive to drive your car from one town/city to another? This intervention introduces a {{PARAMETERS_SCHEMES_B36}} pence congestion charge for car journeys traveling between urban areas.',
    reference: 'RP2',
    oneoff: false,
    credit: -5,
    modelVariable: 'Increase Road Pricing Inter Urban',
    category: 'RP',
  },
  {
    label: 'Constrain workplace parking',
    description:
      'Do you want to reduce the number of available parking spaces? This option reduces the availability of workplace parking by {{PARAMETERS_SCHEMES_B5}}%',
    reference: 'PC7',
    oneoff: false,
    credit: 5,
    modelVariable: 'Constrain Workplace Parking',
    category: 'PC',
  },
  {
    label: 'Introduce workplace parking levy',
    description:
      'Do you want to make it more expensive to park your car at your workplace?  This option introduces a parking chage of {{PARAMETERS_SCHEMES_B34}} pence to workplaces.',
    reference: 'PC8',
    oneoff: false,
    credit: -2,
    modelVariable: 'Introduce Workplace Parking Levy',
    category: 'PC',
  },
  {
    label: 'Speed up electrification of vehicles',
    description:
      'Do you think there should be more electric cars on the road? This option increases the rate of vehilce fleet electrification by {{PARAMETERS_SCHEMES_B46}}% per year.',
    reference: 'PC9',
    oneoff: false,
    credit: 10,
    modelVariable: 'Speed up EV fleet',
    category: 'PC',
  },

  {
    label: 'Improve rail capacity and/or speeds for trips within town/cities',
    description:
      'Do you want rail travel within town and cities to be easier? This intervention increases capacity for rail travel within urban areas by {{PARAMETERS_SCHEMES_B15}}%.',
    reference: 'RL1',
    oneoff: false,
    credit: 25,
    modelVariable: 'Improve Local Route Rail',
    category: 'RL',
  },
  {
    label: 'Improve rail capacity and/or speeds for trips between town/cities',
    description:
      'Do you want rail travel between town and cities to be easier? This intervention increases capacity for rail travel between urban areas by {{PARAMETERS_SCHEMES_B19}}%.',
    reference: 'RL2',
    oneoff: false,
    credit: 35,
    modelVariable: 'Improve Inter Urban Rail',
    category: 'RL',
  },
  {
    label: 'Reduce rail fares',
    description: 'Do you think rail fares are too expensive? This option uniformily reduces rail fares by {{PARAMETERS_SCHEMES_B8}}%.',
    reference: 'RL3',
    oneoff: false,
    credit: 15,
    modelVariable: 'Reduce rail fares',
    category: 'RL',
  },

  {
    label: 'Improve bus capacity and/or speeds for trips within town/cities',
    description:
      'Do you want bus travel within town and cities to be easier? This intervention increases capacity for bus travel within urban areas by {{PARAMETERS_SCHEMES_B16}}%.',
    reference: 'BC1',
    oneoff: false,
    credit: 20,
    modelVariable: 'Improve Local Route Bus',
    category: 'BC',
  },
  {
    label: 'Improve bus capacity and/or speeds for trips between town/cities',
    description:
      'Do you want bus travel between town and cities to be easier? This intervention increases capacity for bus travel between urban areas by {{PARAMETERS_SCHEMES_B20}}%.',
    reference: 'BC2',
    oneoff: false,
    credit: 10,
    modelVariable: 'Improve Inter Urban Bus',
    category: 'BC',
  },
  {
    label: 'Reduce bus fares',
    description: 'Do you think bus fares are too expensive? This option uniformily reduces bus fares by {{PARAMETERS_SCHEMES_B7}}%.',
    reference: 'BC3',
    oneoff: false,
    credit: 15,
    modelVariable: 'Reduce bus fares',
    category: 'BC',
  },

  {
    label: 'Improve walk & cycle environment (within urban areas)',
    description:
      'Would you like to improve walk and cycle options within urban areas? This intervention improves the conditions for active travel within urban areas by {{PARAMETERS_SCHEMES_B10}}%.',
    reference: 'WC4',
    oneoff: false,
    credit: 15,
    modelVariable: 'Local improvements to walk and cycle',
    category: 'WC',
    switches: [
      {
        if: true,
        otherVariable: 'Improve local route capacity and/or speeds',
        action: 'UNCHECK',
      },
    ],
  },
  {
    label: 'Improve walk & cycle environment (between urban areas)',
    description:
      'Would you like to improve walk and cycle options between urban areas? This intervention improves the conditions for active travel between urban areas by {{PARAMETERS_SCHEMES_B21}}%.',
    reference: 'WC5',
    oneoff: false,
    credit: 10,
    modelVariable: 'Improve Inter urban Cycling',
    category: 'WC',
  },

  {
    label: 'Introduce e-bike schemes (increases cycle range)',
    description:
      'Would you like to introduce an e-bike scheme to the region? This measure increases the travel time individuals are willing to travel from 60 mins to 90 mins.',
    reference: 'NM1',
    oneoff: false,
    credit: 10,
    modelVariable: 'Introduce ebikes',
    category: 'NM',
  },
  {
    label: 'Introduce shared vehicle schemes',
    description:
      'Would you like to introduce a car-sharing scheme to the region? This intervention increases the number of non-drivers who can get a lift by {{PARAMETERS_SCHEMES_B27}}%.',
    reference: 'NM2',
    oneoff: false,
    credit: 10,
    modelVariable: 'Introduce shared vehicles',
    category: 'NM',
  },

  {
    label: 'Encourage freight transport to use rail instead of roads',
    description:
      'Do you want to have fewer freight trucks on the roads? This measure shifts freight traffic away from roads and onto rail. Reducing road congestion between towns and cities.',
    reference: 'FR1',
    oneoff: false,
    credit: 10,
    modelVariable: 'Shift freight from car to rail',
    category: 'FR',
  },

  {
    label: 'Discourage the use of car',
    description:
      'Do you think people should use cars less often? This measure makes car usage a less prefered option by decreasing its general attractiveness.',
    reference: 'BE4',
    oneoff: false,
    credit: 10,
    modelVariable: 'Encourage mode shift away from car',
    category: 'BE',
  },
]

const inputReplacementValues = [
  { name: 'PARAMETERS_SCHEMES_B12', value: '20' },
  { name: 'PARAMETERS_SCHEMES_B13', value: '20' },
  { name: 'PARAMETERS_SCHEMES_B24', value: '20' },
  { name: 'PARAMETERS_SCHEMES_B25', value: '20' },
  { name: 'PARAMETERS_SCHEMES_B35', value: '200' },
  { name: 'PARAMETERS_SCHEMES_B36', value: '200' },
  { name: 'PARAMETERS_SCHEMES_B5', value: '10' },
  { name: 'PARAMETERS_SCHEMES_B34', value: '200' },
  { name: 'PARAMETERS_SCHEMES_B46', value: '5' },
  { name: 'PARAMETERS_SCHEMES_B15', value: '20' },
  { name: 'PARAMETERS_SCHEMES_B19', value: '20' },
  { name: 'PARAMETERS_SCHEMES_B8', value: '29' },
  { name: 'PARAMETERS_SCHEMES_B16', value: '21' },
  { name: 'PARAMETERS_SCHEMES_B20', value: '20' },
  { name: 'PARAMETERS_SCHEMES_B7', value: '28' },
  { name: 'PARAMETERS_SCHEMES_B10', value: '5' },
  { name: 'PARAMETERS_SCHEMES_B21', value: '20' },
  { name: 'PARAMETERS_SCHEMES_B27', value: '20' },
]

inputs.forEach((input, index) => {
  inputReplacementValues.forEach((replace) => {
    if (input.description.indexOf(replace.name) > -1) {
      const newInput = input
      newInput.description = input.description.replace(
        `{{${replace.name}}}`,
        replace.value,
      )
      inputs[index] = newInput
    }
  })
})

// We allow for a set number of runs and run-to-end is literally all of those
// We get max 61 numbers in the time series, but 50 is a round number
const maxNumberOfRuns = 20
const runToEndFinishesAt = 20
const runStages = []

Array(maxNumberOfRuns + 1)
  .fill()
  .map((_, i) =>
    runStages.push({
      stepTo: 0.5 * (i + 1),
      label: `${i + 1}`,
    }),
  )

export default {
  runManagerAccount,
  subscriptOptions,
  scenarios,
  inputs,
  inputCategories,
  outputs,
  outputCategories,
  runStages,
  runToEndFinishesAt,
  maxNumberOfRuns,
  totalCredits: 100,
}
